import React from 'react';
import { Check } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-16 md:py-24 bg-emerald-900 text-white overflow-hidden relative" data-id="element-134">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-135"></div>

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <p className="text-emerald-300 font-bold tracking-widest uppercase mb-4" data-id="element-138">
            La Solución Definitiva
          </p>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-139">
            Presentamos: RODILLAS JÓVENES
          </h2>
          <p className="text-2xl md:text-3xl text-emerald-100 font-serif italic" data-id="element-140">
            "El Método de la Silla"
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-12 bg-emerald-800/50 p-8 rounded-3xl border border-emerald-700 backdrop-blur-sm" data-id="element-141">
          <div className="w-full md:w-1/2" data-id="element-142">
            <img src="https://cdn.magicpatterns.com/uploads/iiW3UxfoZG3o1ZJkNarvVS/heyloid1.png" alt="Programa Rodillas Jóvenes" className="w-full h-auto rounded-xl shadow-2xl transform md:-rotate-3 hover:rotate-0 transition-all duration-500" data-id="element-143" />
          </div>

          <div className="w-full md:w-1/2" data-id="element-144">
            <h3 className="text-2xl font-bold mb-6 text-white" data-id="element-145">
              He creado algo pensado exclusivamente para ti:
            </h3>
            <ul className="space-y-6" data-id="element-146">
              {['Para la mujer que no quiere ir a un gimnasio lleno de jóvenes.', 'Para la que no quiere tirarse al suelo a hacer ejercicios raros.', 'Para la que quiere resultados reales desde la comodidad de su sala.', 'Ejercicios de 15 minutos que puedes hacer sentada.'].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-147">
                  <div className="bg-amber-500 rounded-full p-1 mt-1 flex-shrink-0" data-id="element-148">
                    <Check className="h-4 w-4 text-slate-900" strokeWidth={4} data-id="element-149" />
                  </div>
                  <span className="text-lg text-emerald-50" data-id="element-150">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}